const TAX_EXEMPT_COUNTRIES = ['United States', 'Canada'];

export default TAX_EXEMPT_COUNTRIES;
